import { useTranslations } from '@vocab/react';

import { getLocale } from 'src/utils/config';

import translations from './.vocab';

const DEFAULTS = {
  siteSection: 'home',
  currentPage: 'dashboard',
  alertShownType: 'modal',
  alertShownTone: 'promote',
};

export const useFindRecruiterDialogTracking = () => {
  const { t } = useTranslations(translations);
  const locale = getLocale();

  switch (locale) {
    case 'en-MY':
    case 'en-HK':
      return {
        ...DEFAULTS,
        alertShownTitle: 'smarthire',
        alertShownMessage: `${t('Dialog Heading')} - ${t(
          'SmartHire Description',
        )}`,
        alertShownMessageCode: 'smarthire - reduce vacancies cost',
        actionOrigin: 'smarthire modal',
      };
    default:
      return {
        ...DEFAULTS,
        alertShownTitle: 'seek recruiter network',
        alertShownMessage: `${t('Dialog Heading')} - ${t('SRN Description')}`,
        alertShownMessageCode: 'srn - reduce vacancies cost',
        actionOrigin: 'srn modal',
      };
  }
};
